module.exports = __webpack_public_path__ + "img/logo.d40db619.png";